import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import theme from '../../theme';

export const rangeFormat = "%";

export const rangeTxtDisable = {
  startTxt: "(前)",
  endTxt: "(後)"
}

export const rangeTxt = {
  startTxt: "前",
  endTxt: "後"
}

export const inputStyle = {
  width: '125px',
  '& .MuiInputBase-input': {
    color: theme.palette.title.main,
    fontSize: '1.75rem',
    fontWeight: 600,
    height: '45px',
    padding: '8px',
    textAlign: 'right'
  },
}

export const greyTxt = {
  color: theme.palette.grey.w500,
  fontSize: '0.875rem',
  paddingBottom: '12px',
}

export const CustomSlider = styled(Slider)(({ theme }) => ({
  '& .MuiSlider-valueLabel': {
    fontSize: '1rem',
    fontWeight: 600,
    top: 0,
    backgroundColor: 'unset',
    color: theme.palette.title.main,
    '&:before': {
      display: 'none',
    },
    '& *': {
      background: 'transparent',
      color: theme.palette.title.main,
    },
  },
}))